import { useQuery } from "@tanstack/react-query";
import adminApiClient, { ExploreClocksCountResponse } from "api/admin";

export default function useExploreClocksCount(days: number = 1) {
  return useQuery<ExploreClocksCountResponse>({
    queryKey: ["exploreClocksCount", days],
    queryFn: () => adminApiClient.getExploreClocksCount(days),
  });
}
